module.exports = __webpack_public_path__ + "static/media/recurring_assigned.d312caae.svg";